import { Component } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { EditTemplateModalComponent } from './edit-template-modal/edit-template-modal.component';
import { DocumentTemplate, DocumentTemplateApiCallerService, UsedTemplate, UsedTemplateDocuments } from './services/document-template-api-caller.service';
import Swal from 'sweetalert2';
import { EditUsedTemplateComponent } from './edit-used-template/edit-used-template.component';
import { PreviewCompanyDocumentModalComponent } from '../dashboards/files-clients/modals/preview-company-document-modal/preview-company-document-modal.component';

@Component({
  selector: 'app-document-templates',
  templateUrl: './document-templates.component.html',
  styleUrls: ['./document-templates.component.scss']
})
export class DocumentTemplatesComponent {
  dataSource: DocumentTemplate[] = [];
  public documentUses: UsedTemplateDocuments[];
  displayedColumns: string[] = ['name', 'description', 'used', 'createdDate', 'modifiedDate', 'modifiedBy', 'actions'];

  constructor(public dialog: MatDialog, private documentTemplateService: DocumentTemplateApiCallerService) {}

  ngOnInit(): void {
    this.getUsedDocuemntTemplate();
  }

  public getUsedDocuemntTemplate() {
    this.documentTemplateService.getUsesDocumenTemplates().subscribe({
      next:(res) => {
        this.documentUses = res;
        this.loadDocumentTemplates();
      }, 
      error: (err) => {
        console.log(err);
      }
    });
  }

  loadDocumentTemplates(): void {
    const observer = {
      next: (data: DocumentTemplate[]) => {
        this.dataSource = data;
      },
      error: (error: any) => {
        console.error('Error fetching document template', error);
      },
      complete: () => {
        console.log('Document template loaded successfully');
      }
    };

    this.documentTemplateService.getDocumentTemplates().subscribe(observer);
  }

  openEditDialog(event: any, template?): void {
    event.stopPropagation();
    const dialogRef = this.dialog.open(EditTemplateModalComponent, {
      width: '80%',
      height: '98%',
      //minWidth: '800px',
      data: template || null,
      disableClose: true,
    });

    dialogRef.backdropClick().subscribe(() => {
      this.confirmClose(dialogRef);
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadDocumentTemplates();
    });
  }

  public openEditUsedDialog(event: any, template?) {
    event.stopPropagation();
    if(template.used) {
      Swal.fire({
        title: '¿Estás seguro?',
        text: 'Esta Plantilla ya tiene un Uso',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, Cambiar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          const dialogRef = this.dialog.open(EditUsedTemplateComponent, {
            width: '40%',
            height: 'auto',
            data: template || null
          });
          dialogRef.afterClosed().subscribe(result => {
            this.loadDocumentTemplates();
          });
        }
      });
    }
    else {
      const dialogRef = this.dialog.open(EditUsedTemplateComponent, {
        width: '36%',
        height: 'auto',
        data: template || null
      });
      dialogRef.afterClosed().subscribe(result => { 
        this.loadDocumentTemplates();
      });
    }
  }

  public onDelete(event: any, template?: DocumentTemplate): void {
    event.stopPropagation();
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Esta acción eliminará la Plantilla.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.documentTemplateService.deleteDocumentTemplate(template.templateId, false).subscribe({
          next: (result) => {
            Swal.fire({
              icon: 'success',
              titleText: 'Plantilla Eliminada',
            });
            this.loadDocumentTemplates(); 
          },
          error: (err) => {
            Swal.fire({
              icon: 'error',
              titleText: 'Ocurrió un error al eliminar la plantilla',
              text: err.error.message,
            });
            console.error(err);
          }
        });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          icon: 'info',
          titleText: 'Eliminación cancelada',
        });
      }
    });
  }
  
  public OpenPreView(template?: DocumentTemplate) {
    Swal.fire({
      title: 'Vista Previa - ' + template.name,
      html: template.htmlTemplate,
      width: '80%',
      showCloseButton: true,
      showCancelButton: false,
      focusConfirm: false,
      confirmButtonText: 'Cerrar',
      customClass: {
        title: 'swal-custom-title', 
      },
      didOpen: (popup) => {
        const titleElement = popup.querySelector('.swal-custom-title') as HTMLElement;
        if (titleElement) {
          titleElement.style.color = '#003c8a'; 
        }
      },
      showClass: {
        popup: 'animate__animated animate__fadeInDown' 
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutUp' 
      }
    });
  }

  public previewDocument(templateId: number){
    const data = {
      viewOnly: true,
      id: templateId
    };

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.width = '80vw';
    dialogConfig.height = '95vh';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.maxHeight = '95vh';
    dialogConfig.data = data;
    this.dialog.open(PreviewCompanyDocumentModalComponent, dialogConfig);
  }

  private confirmClose(dialogRef: MatDialogRef<EditTemplateModalComponent>): void {
    Swal.fire({
      title: '¿Estás seguro?',
      text: '¿Quieres cerrar el modal? Los cambios no guardados se perderán.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#003c8a',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, cerrar',
      cancelButtonText: 'Cancelar',
    }).then(result => {
      if (result.isConfirmed) {
        dialogRef.close();
      }
    });
  }
  
  getUsedName(valor: number): string {
    for (const use of this.documentUses) { 
      if (use.idUsed === valor) {
        return use.name; 
      }
    }
    return "No Asignado"; 
  }
  

}